import React from "react";
import "../css/waveTop.scss";
export default function WaveTop({ fillColor = "#ddf3f7", strokeColor = "#7FD0EB" }) {
  return (
    <div className="wave-wrapper-top">
      <svg
        viewBox="0 0 1440 200"
        preserveAspectRatio="none"
        className="wave"
      >
        <path
          d="M0,120 C240,40 480,40 720,100 C960,160 1200,160 1440,120 L1440,200 L0,200 Z"
          fill={fillColor}
        />

        {/* top border wave */}
        <path
          d="M0,120 C240,40 480,40 720,100 C960,160 1200,160 1440,120"
          fill="none"
          stroke={strokeColor}
          strokeWidth="6"
        />
      </svg>
    </div>
  );
}



